import React, { useState, useEffect, useRef } from "react";
import {
  Navbar,
  Nav,
  Container,
  Form,
  Button,
  NavDropdown,
} from "react-bootstrap";
//import Logo from "../assets/images/logo.svg";
import Menu from "../assets/images/menu.svg";
import MenuClose from "../assets/images/menu-close.svg";
import ClaseIcon from "../assets/images/close.svg";
import SearchIcon from "../assets/images/search-icon.svg";
import CallIcon from "../assets/images/phone-icon.svg";
import LocationIcon from "../assets/images/location-icon.svg";

import { useDispatch, useSelector } from "react-redux";
import { getPageContent } from "../features/visitor/visitorActions";
import { fetchServices } from "../features/service/serviceActions";
import { logout } from "../features/auth/authActions";
import { useNavigate, Link } from "react-router-dom";

const Header = () => {
  const token =
    localStorage.getItem("token") || sessionStorage.getItem("token"); //useSelector((state) => state.auth);
  const [searchVisible, setSearchVisible] = useState(false);
  const [navbarScrolled, setNavbarScrolled] = useState(false);
  const [headerHeight, setHeaderHeight] = useState(0);

  const [headerData, setHeaderData] = useState(null);
  const [serviceData, setServiceData] = useState([]);

  const headerRef = useRef(null);
  const toggleSearch = () => {
    setSearchVisible(!searchVisible);
  };
  const handleScroll = () => {
    if (window.scrollY > 50) {
      setNavbarScrolled(true);
    } else {
      setNavbarScrolled(false);
    }
  };
  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    const calculateHeaderHeight = () => {
      if (headerRef.current) {
        //setHeaderHeight(headerRef.current.offsetHeight);
        setHeaderHeight(140);
      }
    };

    calculateHeaderHeight();
    window.addEventListener("resize", calculateHeaderHeight);

    return () => {
      window.removeEventListener("scroll", handleScroll);
      window.removeEventListener("resize", calculateHeaderHeight);
    };
  }, []);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { pageResponse } = useSelector((state) => state.visitor);
  const { services } = useSelector((state) => state.service);

  const handleLogout = () => {
    localStorage.removeItem("token");
    sessionStorage.removeItem("token");
    dispatch(logout());
    navigate("/login");
  };

  useEffect(() => {
    dispatch(getPageContent());
    dispatch(fetchServices({ page: 1, limit: 25 }));
  }, [dispatch]);

  useEffect(() => {
    if (pageResponse) {
      let footer = pageResponse.find((r) => r.code === "footer");
      setHeaderData(footer.footer_section);
    }
  }, [pageResponse]);

  useEffect(() => {
    if (services) {
      setServiceData(services?.data);
    }
  }, [services]);

  return (
    <>
      <header>
        <Navbar
          ref={headerRef}
          expand="lg"
          className={`navbar-custom ${navbarScrolled ? "scrolled" : ""}`}
          fixed="top"
        >
          <div className="header-top">
            <Container>
              <Navbar.Brand href="/" title="Personal Care">
                <img
                  src={`${process.env.REACT_APP_PHP_BACKEND_MEDIA_URL}${headerData?.main_logo}`}
                  alt=""
                />
              </Navbar.Brand>
              <Navbar.Toggle aria-controls="navbarText">
                <span className="navbar-toggler-icon">
                  <img src={Menu} className="menu-icon" alt="Menu" />
                  <img src={MenuClose} className="close-icon" alt="Close" />
                </span>
              </Navbar.Toggle>
              <Navbar.Collapse id="navbarText" className="justify-content-end">
                <Nav className="me-auto">
                  <Nav.Link href="/about-us" title="">
                    Who We Are
                  </Nav.Link>
                  <NavDropdown title="Our Services">
                    {serviceData?.length > 0 && (
                      <>
                        {serviceData.map((row, index) => (
                          <li key={"n" + row.id + index}>
                            <NavDropdown.Item
                              href={"/service-details/" + row.slug}
                            >
                              {row.title}
                            </NavDropdown.Item>
                          </li>
                        ))}
                      </>
                    )}
                  </NavDropdown>
                  <Nav.Link href="/resources" title="Resources">
                    Resources
                  </Nav.Link>
                  <Nav.Link href="/career" title="Careers">
                    Careers
                  </Nav.Link>
                  <Nav.Link href="/blogs" title="Careers">
                    Blogs
                  </Nav.Link>

                  <Nav.Link
                    className="mobile-menu"
                    href="/signup-step"
                    title="Where to Begin"
                  >
                    Where to Begin
                  </Nav.Link>
                  {/* <NavDropdown
                    className="mobile-menu"
                    title="Personal Care Life"
                  >
                    <NavDropdown.Item href="">
                      Personal Care Life 1
                    </NavDropdown.Item>
                    <NavDropdown.Item href="">
                      Personal Care Life 2
                    </NavDropdown.Item>
                    <NavDropdown.Item href="">
                      Personal Care Life 3
                    </NavDropdown.Item>
                    <NavDropdown.Item href="">
                      Personal Care Life 4
                    </NavDropdown.Item>
                    <NavDropdown.Item href="">
                      Personal Care Life 5
                    </NavDropdown.Item>
                  </NavDropdown> */}
                </Nav>
                <Form className="d-flex navbar-form-search" role="search">
                  <div
                    className={`search-form-container ${
                      searchVisible ? "" : "hdn"
                    }`}
                    id="search-input-container"
                  >
                    <div className="search-input-group">
                      <Form.Control
                        type="text"
                        placeholder="Search for..."
                        className="form-control"
                      />
                      <Button
                        variant="default"
                        className="close-btn"
                        onClick={toggleSearch}
                      >
                        <img src={ClaseIcon} alt="Close" />
                      </Button>
                    </div>
                  </div>
                  <Button
                    variant="submit"
                    className="search-btn"
                    id="search-button"
                    onClick={toggleSearch}
                  >
                    <img src={SearchIcon} alt="Search" />
                  </Button>
                </Form>
                <Nav.Link
                  href="/signup-step"
                  className="custom-bttn mobile-menu"
                >
                  <img src={LocationIcon} alt="Get Started Icon" /> Get Started
                </Nav.Link>
                <Nav.Link
                  href={"tel:" + headerData?.office_phone_no}
                  className="custom-bttn call-bttn"
                  title={headerData?.office_phone_no}
                >
                  <img src={CallIcon} alt="phone Icon" />{" "}
                  {headerData?.office_phone_no}
                </Nav.Link>
              </Navbar.Collapse>
            </Container>
          </div>
          <div className="header-bottom">
            <Container>
              <div>
                {token === null ? (
                  <Nav.Link href="/login" title="Login">
                    Login
                  </Nav.Link>
                ) : (
                  <>
                    <Nav.Link onClick={handleLogout} title="Logout">
                      Logout
                    </Nav.Link>
                    <Nav.Link as={Link} to="/profile" title="My Profile">
                      My Profile
                    </Nav.Link>
                  </>
                )}

                {/* <NavDropdown className="" title="Personal Care Life">
                  <NavDropdown.Item href="">
                    Personal Care Life 1
                  </NavDropdown.Item>
                  <NavDropdown.Item href="">
                    Personal Care Life 2
                  </NavDropdown.Item>
                  <NavDropdown.Item href="">
                    Personal Care Life 3
                  </NavDropdown.Item>
                  <NavDropdown.Item href="">
                    Personal Care Life 4
                  </NavDropdown.Item>
                  <NavDropdown.Item href="">
                    Personal Care Life 5
                  </NavDropdown.Item>
                </NavDropdown> */}
              </div>
              <div>
                <Nav.Link href="/signup-step" className="custom-bttn">
                  <img src={LocationIcon} alt="Get Started Icon" /> Get Started
                </Nav.Link>
              </div>
            </Container>
          </div>
        </Navbar>
      </header>
      <div style={{ marginTop: `${headerHeight}px` }}></div>
    </>
  );
};

export default Header;
